import { name } from "file-loader";

/**
 * Created by wangkai on 2018/10/30
 * Desc: 订单项目路由表配置
 */
const _import = require('./_import_' + process.env.NODE_ENV);
const orderProjectRoute = [
  //首页
  {
    path: '/',
    name: 'home',
    // component: _import('orderProject/homePage/index'),
    component: _import('orderProject/homePage/home'),
    hidden: true,
    title: '首页'
  },
  // 登录注册
  {
    path: '/login',
    name: 'login',
    component: _import('orderProject/registerAndLogin/login/index'),
    // component: _import('login/index'),
    hidden: true,
    title: '登录',
    meta: { title: '登录' }
  },
  {
    path: '/phoneRegister',
    name: 'phoneRegister',
    component: _import('orderProject/registerAndLogin/phoneRegister/index'),
    hidden: true,
    title: '手机注册',
    meta: { title: '手机注册' }
  },
  {
    path: '/setNickname',
    name: 'setNickname',
    component: _import('orderProject/registerAndLogin/setNickName/index'),
    hidden: true,
    title: '设置头像昵称',
    meta: { title: '设置头像昵称' }
  },
  {
    path: '/setPassword',
    name: 'setPassword',
    component: _import('orderProject/registerAndLogin/setPassword/index'),
    hidden: true,
    title: '设置密码',
    meta: { title: '注册设置密码' }
  },
  //我的店主
  {
    path: '/shopOwner',
    name: 'shopOwner',
    component: _import('orderProject/myShopkeeper/shopOwner/index'),
    hidden: true,
    title: '我的店主'
  },
  {
    path: '/changeShoper',
    name: 'changeShoper',
    component: _import('orderProject/myShopkeeper/changeShoper/index'),
    hidden: true,
    title: '修改店主，验证账户'
  },
  {
    path: '/addChange',
    name: 'addChange',
    component: _import('orderProject/myShopkeeper/addChange/index'),
    hidden: true,
    title: '确认修改手机号'
  },
  //账户安全
  {
    path: '/uhome/more',
    name: 'more',
    component: _import('orderProject/accountSecurity/set/index'),
    hidden: true,
    title: '更多列表页'
  },
  {
    path: '/pages/brand',
    name: 'brand',
    component: _import('orderProject/accountSecurity/aboutUs/index'),
    hidden: true,
    title: '关于我们',
    meta: { title: '关于我们' }
  },
  {
    path: '/treeManager',
    name: 'treeManager',
    component: _import('orderProject/accountSecurity/treeManager/index'),
    hidden: true,
    title: '英树管家',
    meta: { title: '英树管家' }
  },
  {
    path: '/ucenter/account/safety',
    name: 'accountSecurityList',
    component: _import('orderProject/accountSecurity/accountSecurityList/index'),
    hidden: true,
    title: '账户安全设置'
  },
  {
    path: '/ucenter/account/safety_mobile',
    name: 'bindPhone',
    component: _import('orderProject/accountSecurity/bindPhone/index'),
    hidden: true,
    title: '绑定手机'
  },
  {
    path: '/changePhone',
    name: 'changePhone',
    component: _import('orderProject/accountSecurity/changePhone/index'),
    hidden: true,
    title: '修改手机'
  },
  {
    path: '/changePhoneR',
    name: 'changePhoneR',
    component: _import('orderProject/accountSecurity/changePhoneR/index'),
    hidden: true,
    title: '确认修改手机'
  },
  {
    path: '/ucenter/account/safety_email',
    name: 'accountMailbox',
    component: _import('orderProject/accountSecurity/bindMailbox/index'),
    hidden: true,
    title: '绑定邮箱'
  },

  {
    path: '/changeMaibox',
    name: 'changeMaibox',
    component: _import('orderProject/accountSecurity/changeMaibox/index'),
    hidden: true,
    title: '修改邮箱'
  },
  {
    path: '/changeMaiboxR',
    name: 'changeMaiboxR',
    component: _import('orderProject/accountSecurity/changeMaiboxR/index'),
    hidden: true,
    title: '确定修改邮箱'
  },
  {
    path: '/codeWay',
    name: 'codeWay',
    component: _import('orderProject/accountSecurity/codeWay/index'),
    hidden: true,
    title: '验证方式'
  },
  {
    path: '/forgetPassword',
    name: 'forgetPassword',
    component: _import('orderProject/accountSecurity/forgetPassword/index'),
    hidden: true,
    title: '忘记密码手机号验证'
  },
  {
    path: '/forgetPasswordU',
    name: 'forgetPasswordU',
    component: _import('orderProject/accountSecurity/forgetPasswordU/index'),
    hidden: true,
    title: '未登录时忘记密码手机号验证'
  },
  {
    path: '/forgetPasswordUE',
    name: 'forgetPasswordUE',
    component: _import('orderProject/accountSecurity/forgetPasswordUE/index'),
    hidden: true,
    title: '未登录时忘记密码邮箱验证'
  },
  {
    path: '/forgetPasswordE',
    name: 'forgetPasswordE',
    component: _import('orderProject/accountSecurity/forgetPasswordE/index'),
    hidden: true,
    title: '忘记密码邮箱验证'
  },

  {
    path: '/ucenter/account/safety_password',
    name: 'changePassword',
    component: _import('orderProject/accountSecurity/changePassword/index'),
    hidden: true,
    title: '修改密码'
  },
  {
    path: '/makePassword',
    name: 'makePassword',
    component: _import('orderProject/accountSecurity/setPassword/index'),
    hidden: true,
    title: '账户安全设置密码'
  },

  //地址管理
  {
    path: '/ucenter/account/address',
    name: 'address',
    component: _import('orderProject/addressManagementModule/addressManagement/index'),
    hidden: true,
    title: '地址管理' + ''
  },
  {
    path: '/ucenter/account/AddressInfo',
    name: 'AddressInfo',
    component: _import('orderProject/addressManagementModule/addressEdit/index'),
    hidden: true,
    title: '地址新增'
  },
  {
    path: '/ucenter/account/AddressInfo/:id',
    name: 'AddressInfo_update',
    component: _import('orderProject/addressManagementModule/addressEdit/index'),
    hidden: true,
    title: '地址编辑'
  },
  //优惠券
  {
    path: '/ucenter/account/coupons',
    name: 'coupons',
    component: _import('orderProject/couponModule/coupon/index'),
    hidden: true,
    title: '优惠券'
  },
  {
    path: '/couponsOrder',
    name: 'couponsOrder',
    component: _import('orderProject/couponModule/couponsOrder/index'),
    hidden: true,
    title: '订单可用优惠券'
  },
  //搜索
  {
    path: '/searchGoodPage',
    name: 'searchGoodPage',
    component: _import('orderProject/search/searchGoodPage/index'),
    hidden: true,
    title: '搜索商品页'
  },
  {
    path: '/searchOrderPage',
    name: 'searchOrderPage',
    component: _import('orderProject/search/searchOrderPage/index'),
    hidden: true,
    title: '搜索订单页'
  },
  {
    path: '/searchGoodDetail',
    name: 'searchGoodDetail',
    component: _import('orderProject/search/searchGoodDetail/index'),
    hidden: true,
    title: '搜索商品结果页'
  },
  {
    path: '/searchOrderDetail',
    name: 'searchOrderDetail',
    component: _import('orderProject/search/searchOrderDetail/index'),
    hidden: true,
    title: '搜索订单结果页'
  },

  //查看管家订单物流
  {
    path: '/lookFlowB',
    name: 'lookFlowB',
    component: _import('orderProject/flow/lookFlowB/index'),
    hidden: true,
    title: '查看物流经销商端',
    meta: { title: '查看物流' }
  },
  //查看门店道具物流
  {
    path: '/lookFlowD',
    name: 'lookFlowD',
    component: _import('orderProject/flow/lookFlowD/index'),
    hidden: true,
    title: '查看门店道具物流',
    meta: { title: '查看物流' }
  },
  {
    path: '/lookFlowC',
    name: 'lookFlowC',
    component: _import('orderProject/flow/lookFlowC/index'),
    hidden: true,
    title: '查看物流会员端',
    meta: { title: '查看物流' }
  },
  {
    path: '/flowDetail',
    name: 'flowDetail',
    component: _import('orderProject/flow/flowDetail/index'),
    hidden: true,
    title: '物流详情',
    meta: { title: '查看物流' }
  },
  {
    path: '/sendGoods',
    name: 'sendGoods',
    component: _import('orderProject/flow/sendGoods/index'),
    hidden: true,
    title: '发货商品',
    meta: { title: '发货商品' }
  },
  {
    path: '/storeSendGoods',
    name: 'storeSendGoods',
    component: _import('orderProject/flow/storeSendGoods/index'),
    hidden: true,
    title: '发货商品',
    meta: { title: '发货商品' }
  },

  //退款流程
  {
    path: '/refoundFlow',
    name: 'refoundFlow',
    component: _import('orderProject/refoundFlow/index'),
    hidden: true,
    title: '退款流程',
    meta: { title: '退款流程' }
  },

  //消息中心
  {
    path: '/notice',
    name: 'notice',
    component: _import('orderProject/noticeModule/notice/index'),
    hidden: true,
    title: '消息中心'
  },
  {
    path: '/notice/publicNotice',
    name: 'publicNotice',
    component: _import('orderProject/noticeModule/publicNotice/index'),
    hidden: true,
    title: '公告'
  },
  {
    path: '/notice/publicNotice/preView',
    name: 'publicNoticePreView',
    component: _import('orderProject/noticeModule/publicNotice/preView'),
    hidden: true,
    title: '公告'
  },
  {
    path: '/notice/publicNotice/detail',
    name: 'publicNoticeDetail',
    component: _import('orderProject/noticeModule/publicNotice/detail/index'),
    hidden: true,
    title: '公告详情',
    meta: { title: '公告详情' }
  },
  {
    path: '/notice/myOrder',
    name: 'myOrder',
    component: _import('orderProject/noticeModule/myOrder/index'),
    hidden: true,
    title: '我的订单'
  },
  {
    path: '/notice/property',
    name: 'property',
    component: _import('orderProject/noticeModule/property/index'),
    hidden: true,
    title: '我的资产'
  },

  // ----  H5 活动页  -------
  {
    path: '/h5/:id',
    name: 'message',
    component: _import('orderProject/h5Module/index'),
    hidden: true,
    title: '',
    meta: { title: '活动' }
  },
  {
    path: '/h5',
    name: 'message',
    component: _import('orderProject/h5Module/index'),
    hidden: true,
    title: '',
    meta: { title: '活动' }
  },
  {
    path: '/h5/preView/:id',
    name: 'messagePreView',
    component: _import('orderProject/h5Module/preView'),
    hidden: true,
    title: ''
  },


  // ----  购物车start   ----
  {
    path: '/shoppingCart',
    name: 'shoppingCart',
    component: _import('orderProject/shoppingCart/index'),
    hidden: true,
    title: '购物车'
  },

  {
    path: '/cart',
    name: 'cart',
    component: _import('orderProject/shoppingCart/index'),
    hidden: true,
    title: '购物车'
  },

  // ----  购物车end  ----

  {
    title: '商品列表',
    path: '/product',
    name: 'product',
    component: _import('orderProject/choose/index'),
    hidden: true,
  },
  {
    title: '商品详情',
    path: '/product/details',
    name: 'commodityDetail',
    component: _import('orderProject/commodityDetail/index'),
    hidden: true,
  },

  // 购物车分享页面
  {
    path: '/shareGoods',
    name: 'shareGoods',
    component: _import('orderProject/shareGoods/index'),
    hidden: true,
    title: '分享商品'
  },
  // 发现分享页面
  {
    path: '/discoverShare',
    name: 'discoverShare',
    component: _import('orderProject/discoverShare/index'),
    hidden: true,
    title: '英树管家'
  },
  {
    path: '/fullofgifts',
    name: 'fullofgifts',
    component: _import('orderProject/fullofgifts/index'),
    hidden: true,
    title: '购物车-查看赠品'
  },
  {
    path: '/redemptionShop',
    name: 'redemptionShop',
    component: _import('redemptionShop/index'),
    hidden: true,
    title: '购物车-换购'
  },
  {
    path: '/orderConfirm',
    name: 'orderConfirm',
    component: _import('orderProject/orderConfirm/index'),
    hidden: true,
    title: '订单确认页'
  },
  {
    path: '/ucenter/order/plist/buyer',
    name: 'orderCenter',
    component: _import('orderProject/orderCenter/index'),
    hidden: true,
    title: '订单列表'
  },
  {
    path: '/orderDetail/:id',
    name: 'orderDetail',
    component: _import('orderProject/orderDetail/index'),
    hidden: true,
    title: '订单详情'
  },
  // 运费规则
  {
    path: '/freight',
    name: 'freight',
    component: _import('orderProject/freight/index'),
    hidden: true,
    title: '运费规则',
    meta: { title: '运费规则' }
  },
  // 支持钱包
  {
    path: '/supportWallet',
    name:'freight',
    component: _import('wallet/supportWallet/index'),
    hidden: true,
    title: '支持钱包',
    meta: {title: '支持钱包'}
  },
  //银行编码
  {
    path:'/bankCodeSearch',
    name:'bankCodeSearch',
    component: _import('wallet/bankCodeSearch/index'),
    hidden: true,
    title: '银行编码产考',
    meta: {title: '银行编码产考'}
  },{
    path:'/cancelAccount',
    name:'cancelAccount',
    component: _import('orderProject/accountSecurity/cancelAccount/index'),
    hidden: true,
    title: '注销账号',
    meta: {title: '注销账号'}
  }
];


export default orderProjectRoute;



// WEBPACK FOOTER //
// ./src/router/orderProject.js